import useSWR from 'swr';
import { useHistory } from 'react-router-dom';
import { stringify } from 'query-string';
import { fetcher } from '../../common/api/fetcher';
import React, { useContext } from 'react';
import ErrorBox from '../../common/components/ErrorBox';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import { UserContext } from '../../common/context/userContext';
import { NoResults } from '../../common/components/NoResults';

export const BrandsDataList = ({ offset, limit, query, setOffset }) => {
  const history = useHistory();
  const { isAdmin } = useContext(UserContext);
  const { data, error, revalidate } = useSWR(
    `/portal/brands?${stringify({
      offset,
      limit,
      includeEdits: true,
      ...(query !== '' && { query }),
    })}`,
    fetcher,
    { suspense: true }
  );

  if (error) {
    return (
      <ErrorBox
        title="Error"
        msg="There was an error fetching brands, please try again"
        onClose={revalidate}
      />
    );
  }

  if (data?.length === 0) {
    return <NoResults />;
  }

  return (
    <div>
      <Table striped bordered hover>
        <tbody>
          {data.map((item) => {
            const productIsLocked = item.hasOpenEdits && !isAdmin;
            return (
              <tr
                key={item.id}
                className={productIsLocked ? '' : 'cursor-pointer'}
              >
                <td
                  onClick={() =>
                    productIsLocked
                      ? {}
                      : history.push(`/brands/edit/${item.id}`)
                  }
                >
                  {item.name}{' '}
                  {item.awaitingApproval && (
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
                      <svg
                        className="-ml-0.5 mr-1.5 h-2 w-2 text-red-400"
                        fill="currentColor"
                        viewBox="0 0 8 8"
                      >
                        <circle cx={4} cy={4} r={3} />
                      </svg>
                      Awaiting Approval
                    </span>
                  )}
                  {item.hasOpenEdits && (
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
                      <svg
                        className="-ml-0.5 mr-1.5 h-2 w-2 text-red-400"
                        fill="currentColor"
                        viewBox="0 0 8 8"
                      >
                        <circle cx={4} cy={4} r={3} />
                      </svg>
                      Edits Awaiting Approval
                    </span>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
      <Button
        variant="secondary"
        type="button"
        className="mr-3 border-orange-br bg-orange-br"
        disabled={offset === 0}
        onClick={() => setOffset(offset - limit)}
      >
        Previous
      </Button>
      <Button
        variant="secondary"
        type="button"
        className="border-orange-br bg-orange-br"
        onClick={() => setOffset(offset + limit)}
      >
        Next
      </Button>
    </div>
  );
};
